(ns dre.pages.shared.views
  (:require
   [clojure.string :as str]
   [dre.app.router :as router :refer [->route]]
   [dre.components.inputs :refer [input-search]]
   [dre.components.pill :as pill]
   [dre.components.tabs :refer [tabs]]
   [dre.components.table :refer [table]]
   [dre.i18n.events :as-alias i18n]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.utils :refer [tr-later]]
   [dre.pages.shared.events :as-alias events]
   [dre.page-util :refer [md]]
   [dre.utils.bem :as bem]
   [dre.shared.interface.search.blunt :as blunt]
   [re-frame.core :as rf]
   [dre.components.breadcrumb :as breadcrumb]))


(def component-name :shared)

(def tab-items
  [{:id :shared
    :label (tr-later "Shared Searches")}])

(defn view
  []
  (let [shared @(rf/subscribe [::events/shared])]
    [:div
     {:class component-name}
     [:div
      {:class (bem/be component-name :nav)}
      [breadcrumb/breadcrumb @(rf/subscribe [::breadcrumb/items])]]
     [:div
      {:class (bem/be component-name :header)}
      [:div
       {:class (bem/be component-name :search-bar)}
       [input-search
        {:placeholder @(rf/subscribe [::i18n/translate "Find..."])
         :on-change (fn [e] (rf/dispatch [::events/set-shared-filter (str (.-value (.-target e)))]))
         :value @(rf/subscribe [::events/shared-filter])}]]]
     [:div
      {:class (bem/be component-name :content)}
      [table
       {:columns [{:title [tr "Title"]
                   :render (fn [{:keys [description object-id]}]
                             (let [parsed-object-id (str/split object-id "&")
                                   query-params (if (= 1 (count parsed-object-id))
                                                  {:query object-id}
                                                  {:query (last parsed-object-id) :order (first parsed-object-id)})
                                   navigate!
                                   #(do
                                      (rf/dispatch [::router/redirect-to-path-with-query-params (->route :search) query-params]))]
                               [:a
                                {:on-click navigate!}
                                description]))
                   :dataIndex :description
                   :sorter :default}
                  {:title [tr "Query"]
                   :render (fn [{:keys [object-id]}]
                             (let [parsed-object-id (str/split object-id "&")
                                   query-params (if (= 1 (count parsed-object-id))
                                                  {:query object-id}
                                                  {:query (last parsed-object-id) :order (first parsed-object-id)})]
                               [pill/readonly-pills (blunt/parse (:query query-params)) (:order query-params) nil nil {}]))}
                  {:title [tr "Sender"]
                   :render (fn [{:keys [type]}]
                             [md type])}]
        :dataSource shared
        :loading? @(rf/subscribe [::events/loading?])
        :pagination {:defaultPageSize 10
                     :hideOnSinglePage true}}]]]))
